import styled from 'styled-components';
import { COLORS } from '../../../../func/components/Color';
import { ReportFormatNumber } from '../../../../func/Function';
import Charts from './Charts';
import { useReportContext } from '../../../../context/DetailContext';
import { use, useEffect, useState } from 'react';
import { userGradeType } from '../../../../utils/auth';
import SaleStatisticsLimit from './SaleStatisticsLimit';

interface SaleStatisticsProps {
  expectedValueList: any;
  expectedValueList2: any;
  expectedValueList2Info: any;
  isExample?: boolean;
}

const SaleStatistics = ({
  expectedValueList,
  expectedValueList2,
  expectedValueList2Info,
  isExample,
}: SaleStatisticsProps) => {
  const [userGrade, setUserGrade] = useState<string | null>(null);

  useEffect(() => {
    if (isExample) return;
    const fetchUserGrade = async () => {
      try {
        const grade = await userGradeType();
        setUserGrade(grade);
      } catch (error) {
        console.error('유저 등급 정보 가져오기 실패:', error);
      }
    };

    fetchUserGrade();
  }, []);
  const { type } = useReportContext();
  const referenceDataTitle = [
    ...expectedValueList.map((_: any, idx: number) => ({
      title: `${idx + 1}차`,
    })),
  ];

  const [monthTab, setMonthTab] = useState(0);
  const [courtData, setCourtData] = useState<any>();

  useEffect(() => {
    setCourtData(expectedValueList2[monthTab]);
  }, [expectedValueList2, monthTab]);

  return (
    <DetailContainer id="매각통계">
      <DetailWrap>
        <TitleBox style={{ lineHeight: '31.90px' }}>매각통계</TitleBox>
        <DetailBox>
          <DecBox>
            <Dectitle>
              <Circle /> 법원 통계 근거자료
            </Dectitle>
            <Dectitle>
              <span>
                {`최근 1년 ${type === 'a' ? '법원경매' : '온비드공매'} 통계`}
              </span>
            </Dectitle>
          </DecBox>
          {/* Todo: 지역 멤버십 연결 */}
          {/* <CourtDataWrapper style={{ marginBottom: '60px' }}>
            <CourtDataTitleBox>
              <img
                src="/assets/images/icon/detail_calendar.svg"
                alt=""
                width={20}
                height={20}
              />
              <div>기간</div>
            </CourtDataTitleBox>
            <SaleStatisticsLimit isRegion />
          </CourtDataWrapper> */}
          {!isExample && !userGrade ? (
            <CourtDataWrapper style={{ marginBottom: '60px' }}>
              <CourtDataTitleBox>
                <img
                  src="/assets/images/icon/detail_calendar.svg"
                  alt=""
                  width={20}
                  height={20}
                />
                <div>기간</div>
              </CourtDataTitleBox>
              <SaleStatisticsLimit />
            </CourtDataWrapper>
          ) : (
            <CourtDataWrapper>
              <CourtDataTitleBox>
                <img
                  src="/assets/images/icon/detail_calendar.svg"
                  alt=""
                  width={20}
                  height={20}
                />
                <div>기간</div>
              </CourtDataTitleBox>
              <MonthTabBox>
                <MonthTab
                  onClick={() => setMonthTab(0)}
                  active={monthTab === 0}
                >
                  3개월
                </MonthTab>
                <MonthTab
                  onClick={() => setMonthTab(1)}
                  active={monthTab === 1}
                >
                  6개월
                </MonthTab>
                <MonthTab
                  onClick={() => setMonthTab(2)}
                  active={monthTab === 2}
                >
                  12개월
                </MonthTab>
              </MonthTabBox>
              <CourtDataTableWrapper>
                {courtData ? (
                  <SingleRowTable>
                    <TableRow>
                      <SingleRowTableHeadCell width="30%">
                        매각건수
                      </SingleRowTableHeadCell>
                      <SingleRowTableBodyCell width="70%">
                        {courtData.dealno ? courtData.dealno : 0}건
                      </SingleRowTableBodyCell>
                    </TableRow>
                    <TableRow>
                      <SingleRowTableHeadCell width="30%">
                        평균감정가
                      </SingleRowTableHeadCell>
                      <SingleRowTableBodyCell width="70%">
                        {ReportFormatNumber(
                          courtData.avgappraisalprice,
                          false,
                          false,
                        )}
                      </SingleRowTableBodyCell>
                    </TableRow>
                    <TableRow>
                      <SingleRowTableHeadCell width="30%">
                        평균매각가
                      </SingleRowTableHeadCell>
                      <SingleRowTableBodyCell width="70%">
                        {ReportFormatNumber(
                          courtData.avgsaleprice,
                          false,
                          false,
                        )}{' '}
                      </SingleRowTableBodyCell>
                    </TableRow>
                    <TableRow>
                      <SingleRowTableHeadCell width="30%">
                        매각가율
                      </SingleRowTableHeadCell>
                      <SingleRowTableBodyCell width="70%">
                        {ReportFormatNumber(courtData.salepricerate, true)}
                      </SingleRowTableBodyCell>
                    </TableRow>
                    <TableRow>
                      <SingleRowTableHeadCell width="30%">
                        평균유찰수
                      </SingleRowTableHeadCell>
                      <SingleRowTableBodyCell width="70%">
                        {courtData.avgbidno
                          ? courtData.avgbidno + ' 회'
                          : 0 + ' 회'}
                      </SingleRowTableBodyCell>
                    </TableRow>
                  </SingleRowTable>
                ) : (
                  NoDataMessage('court')
                )}
                <Desription>
                  *법원경매 통계는 '
                  {expectedValueList2Info && expectedValueList2Info.region} 중{' '}
                  {expectedValueList2Info && expectedValueList2Info.category}'
                  를 조건으로 하는 물건을 대상으로 작성되었습니다.
                </Desription>
              </CourtDataTableWrapper>
            </CourtDataWrapper>
          )}
        </DetailBox>
        {/*1안 */}
        {(isExample || userGrade) && (
          <DetailBox>
            <DetailBox>
              <DecBox>
                <Dectitle>
                  <Circle /> AI 산출 매각 기대값 근거자료
                </Dectitle>
                <Dectitle>
                  <span>
                    {'최근 1년 지역별/용도별 매각 물건 빅데이터 분석 기준'}
                  </span>
                </Dectitle>
              </DecBox>
              <Charts chartData={expectedValueList}></Charts>
              <Table>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead style={{ width: '100%' }}>
                    <tr>
                      <TableHeadTh width="13%" rowSpan={1}>
                        구분
                      </TableHeadTh>
                      <TableHeadTh width="29%" colSpan={1}>
                        매각율
                      </TableHeadTh>
                      <TableHeadTh width="29%" rowSpan={1}>
                        매각가율{' '}
                      </TableHeadTh>
                      <TableHeadTh width="29%" rowSpan={1}>
                        매각기대율{' '}
                      </TableHeadTh>
                    </tr>
                  </thead>
                  <tbody style={{ width: '100%' }}>
                    {referenceDataTitle.length > 0 &&
                      expectedValueList.length > 0 &&
                      expectedValueList.map((item: any, index: any) => (
                        <tr
                          style={{ borderBottom: '1px solid #e8e9ea' }}
                          key={index}
                        >
                          <TablebodyTd width="13%">
                            {referenceDataTitle[index].title}
                          </TablebodyTd>
                          <TablebodyTd width="29%">
                            {ReportFormatNumber(item.salerate, true)}
                          </TablebodyTd>
                          <TablebodyTd width="29%">
                            {ReportFormatNumber(item.salerricerate, true)}
                          </TablebodyTd>
                          <TablebodyTd width="29%">
                            {ReportFormatNumber(
                              item.expectedsalepricerate,
                              true,
                            )}
                          </TablebodyTd>
                        </tr>
                      ))}
                    {expectedValueList.length === 0 && NoDataMessage('')}
                  </tbody>
                </table>
              </Table>
            </DetailBox>
          </DetailBox>
        )}
      </DetailWrap>
    </DetailContainer>
  );
};

export default SaleStatistics;

function NoDataMessage(type: string) {
  if (type === 'court') {
    return (
      <div style={{ width: '100%', borderTop: '1px solid #222' }}>
        <table style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <TableHeadTh width={'20%'}>매각건수</TableHeadTh>
              <TableHeadTh width={'20%'}>평균감정가</TableHeadTh>
              <TableHeadTh width={'20%'}>평균매각가</TableHeadTh>
              <TableHeadTh width={'20%'}>매각가율</TableHeadTh>
              <TableHeadTh width={'20%'}>평균유찰수</TableHeadTh>
            </tr>
          </thead>
          <tbody>
            <TablebodyTd width={'100%'} colSpan={5}>
              데이터가 없습니다.
            </TablebodyTd>
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <tr>
        <TablebodyTd width={'100%'} colSpan={4}>
          데이터가 없습니다.
        </TablebodyTd>
      </tr>
    );
  }
}

const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #171e26;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e8e9ea;
  &:first-child {
    border-top: 1px solid #222;
  }
`;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CourtDataTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface MonthTabProps {
  active: boolean;
}

const MonthTab = styled.div<MonthTabProps>`
  display: flex;
  flex-direction: row;
  padding: 6px 16px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 9999px;
  color: ${({ active }) => (active ? '#008AFF' : '#989BA2')};
  background-color: ${({ active }) =>
    active ? '#fff' : 'rgba(112, 115, 124, 0.08)'};
  border: ${({ active }) => (active ? '1px solid #008AFF' : 'none')};
`;

const MonthTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const CourtDataTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;

  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;
`;

const CourtDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Circle = styled.div`
  width: 4px;
  height: 4px;
  background-color: black;
  border-radius: 50%;
`;

const DetailBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: 'Spoqa Han Sans Neo';
  gap: 24px;
`;

const DecBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid #e8e9ea;
  padding: 12px 16px;
`;
const Dectitle = styled.span`
  text-align: left;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-weight: 700;
  line-height: 18.85px;
  letter-spacing: -0.65px;
  color: #616161;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  span {
    color: rgba(55, 56, 60, 0.61);
    font-size: 13px;
    font-weight: 500;
  }
`;

const Table = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-top: 1px solid #222;
`;

const Desription = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #008aff;
`;

const DetailContainer = styled.div`
  width: 100%;
  padding: 32px 16px;
  background-color: white;
`;

const DetailWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  gap: 24px;
  font-family: 'Spoqa Han Sans Neo';
`;

const TitleBox = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 700;
  line-height: 23.2px;
  letter-spacing: -0.8px;
  line-height: 23.2px;
  width: 100%;
`;

const TableColumnDirection = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
interface WidthProps {
  width: string;
}

const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;

  &:last-child {
    border-right: none;
  }
`;
